/**
 * @flow
 * @relayHash c708296be1817103e9a5169d5c7daed7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SharedSaveSearchMutationVariables = {|
  searchTypes?: ?$ReadOnlyArray<?"SEARCH" | "SELLER" | "DESIGNER" | "USER_PREFERENCE" | "SEARCH_HISTORY">;
  searchPages?: ?$ReadOnlyArray<?string>;
  input: {
    page: string;
    name?: ?string;
    query?: ?string;
    type: string;
    userId: string;
    favoriteId?: ?string;
    action: "ADD" | "REMOVE";
    clientMutationId?: ?string;
  };
|};
export type SharedSaveSearchMutationResponse = {|
  +favoritePage: ?{|
    +user: ?{|
      +savedSearches: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +serviceId: ?string;
          |};
        |}>;
      |};
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "searchTypes",
        "type": "[types]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "searchPages",
        "type": "[String]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FavoritePageInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedSaveSearchMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FavoritePageInput!"
          }
        ],
        "concreteType": "FavoritePagePayload",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "savedSearches",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "pages",
                    "variableName": "searchPages",
                    "type": "[String]"
                  },
                  {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "searchTypes",
                    "type": "[types]"
                  }
                ],
                "concreteType": "favoritesConnection",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "app-buyer-finding/192.0.0-2018-11-06T15:45:14.027Z/SharedSaveSearchMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "SharedSaveSearchMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "searchTypes",
        "type": "[types]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "searchPages",
        "type": "[String]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FavoritePageInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SharedSaveSearchMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FavoritePageInput!"
          }
        ],
        "concreteType": "FavoritePagePayload",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "savedSearches",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "pages",
                    "variableName": "searchPages",
                    "type": "[String]"
                  },
                  {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "searchTypes",
                    "type": "[types]"
                  }
                ],
                "concreteType": "favoritesConnection",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
